let nextId = 0

export function init(graph){

}
export function getNextId(){
    return nextId++
}